import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=475041b1&scoped=true&"
var script = {}
import style0 from "./Section1.vue?vue&type=style&index=0&id=475041b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475041b1",
  null
  
)

export default component.exports